export default imporvibegram.chatta.ROLLDOWN_FILE_URL_6kssa3xCT2YlMpIbbRNP$Q